<template>
  <ValidationObserver ref="observer">
    <v-form ref="createForm" @submit.prevent>
      <v-row>
        <v-col
          v-for="(field, fieldKey) in fields"
          cols="12"
          :sm="field.sm ? field.sm : 12"
          :key="fieldKey"
        >
          <WsState
            :type="field.type"
            :label="field.label"
            :fields="field.fields"
            :rules="field.rules"
            :hasCloseChips="field.hasCloseChips"
            :displayLabel="field.displayLabel"
            :uploadUrl="field.uploadUrl"
            :autofocus="field.autofocus"
            :items="field.items"
            :textKey="field.textKey"
            :modelName="field.modelName"
            :getText="field.getText"
            :value="updateData[fieldKey]"
            @input="$emit('input', fieldKey, $event)"
            :originValue="fetchValue[fieldKey]"
            :originData="updateData"
            :customParentData="customParentData"
            :displayCheck="field.displayCheck"
            :getRules="field.getRules"
            :originDataEX="value"
            :customFunction="field.customFunction"
            :isLink="field.isLink"
            :conditions="$_getConditions(field.conditionKeys)"
            :module="field.module"
            :orderBy="field.orderBy"
            :orderWay="field.orderWay"
          />
        </v-col>
      </v-row>
    </v-form>
  </ValidationObserver>
</template>

<script>
// WsDataExpandListItem 的編輯表單 body，抽出共用：虛擬滾動時放 WsDialog、非虛擬時 inline。
export default {
  props: {
    fields: {
      type: Object,
      default: null,
    },
    updateData: {
      type: Object,
      default() {
        return {};
      },
    },
    fetchValue: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default: null,
    },
    customParentData: {
      type: Object,
    },
    modelData: {
      type: Object,
    },
  },
  methods: {
    $_getConditions(conditionKeys) {
      if (!conditionKeys) return [];
      const conditions = [];
      conditionKeys.forEach((conditionKey) => {
        const value =
          this.modelData && this.modelData[conditionKey.fieldName]
            ? this.modelData[conditionKey.fieldName].map((conditionData) =>
                conditionData.id ? conditionData.id : conditionData,
              )
            : null;
        conditions.push({
          key: conditionKey.conditionName,
          value,
          type: conditionKey.type,
        });
      });
      return conditions;
    },
    // 提供給父層（item）的 $_onUpdateSubmit 呼叫
    validate() {
      return this.$refs.observer.validate();
    },
  },
};
</script>
